<template>
  <div class="sidebar-user text-center">
    <div class="avatar-wrap">
      <div class="avatar-initials">{{ initials }}</div>
    </div>

    <router-link to="/owner/dashboard">
      <h6 class="mt-3 f-14 f-w-600 mb-0">{{ displayName }}</h6>
    </router-link>
    <div class="sidebar-subtitle">{{ subtitle }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: null,
    };
  },
  computed: {
    displayName() {
      return this.user?.name || this.user?.email || 'Admin';
    },
    subtitle() {
      if (this.user?.company?.name) return this.user.company.name;
      if (this.user?.roles?.length) {
        const role = typeof this.user.roles[0] === 'string' ? this.user.roles[0] : this.user.roles[0].name;
        return role.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
      }
      return 'Administrator';
    },
    initials() {
      const source = this.user?.name || this.user?.email || '?';
      return source
        .split(/[\s@]/)
        .filter(Boolean)
        .map((p) => p[0])
        .slice(0, 2)
        .join('')
        .toUpperCase();
    },
  },
  mounted() {
    this.loadUser();
    window.addEventListener('storage', this.loadUser);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.loadUser);
  },
  methods: {
    loadUser() {
      try {
        const raw = localStorage.getItem('getlokal_admin_user');
        this.user = raw ? JSON.parse(raw) : null;
      } catch {
        this.user = null;
      }
    },
  },
};
</script>

<style scoped>
.avatar-wrap {
  display: flex;
  justify-content: center;
  margin-top: 4px;
}
.avatar-initials {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--theme-deafult, #900C27);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.sidebar-user h6 {
  color: inherit;
}
.sidebar-subtitle {
  display: block !important;
  width: 100% !important;
  text-align: center !important;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  margin-top: 2px;
}
</style>
